import React from 'react';
import { getBuiltInBulletConfigByType } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/character-utils/built-in-bullet';
import { isSupportFontFamily } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/check-font-is-supported';

interface Props {
    // 项目符号的类型
    type: string
}

/**
 * 获取项目编号图标的渲染
 * @param props
 * @returns
 */
export default function BulletSymbol(props: Props) {
    const { type } = props;
    const config = getBuiltInBulletConfigByType(type);
    if (!config) {
        return null;
    }
    const { char, fontFamily, backup } = config;

    // 检查当前字体是否支持
    const isSupport = isSupportFontFamily(fontFamily, char);
    if (isSupport) {
        return (
            <span style={{ fontFamily }}>{char}</span>
        );
    }
    return (
        <span style={{ fontFamily: backup.fontFamily }}>{backup.char}</span>
    );
}
